import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ConfirmationModal, Spinner } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { ActivityLogItem } from '~/components/ActivityLogItem/ActivityLogItem';
import GenericError from '~/components/GenericError/GenericError';
import { useActivityLog } from '~/hooks/reactQuery/queries/useActivityLog';
import { useRelationship } from '~/hooks/reactQuery/queries/useRelationship';
import { useLocaleKeys } from '~/i18n';
import { relationshipModel } from '~/models';
import styles from './ActivityLogModal.module.scss';
export const GetActivityLogModalTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            ActivityLogModalTID: {
                Root: 'activity-log-modal'
            }
        }
    });
export default function ActivityLogModal(param) {
    let { relationshipId, dismissModal } = param;
    const { t: proposalsDashboardTexts } = useLocaleKeys('pages.proposalsDashboard');
    const { t: commonTexts } = useLocaleKeys('common');
    const { ActivityLogModalTID } = useMemo(()=>GetActivityLogModalTID(), []);
    const closeModal = ()=>dismissModal();
    const { relationship, isLoading: relationshipLoading, error: relationshipError } = useRelationship(relationshipId, {
        refreshOnMount: true
    });
    const { activityLog, isLoading: activityLogLoading, error: activityLogError } = useActivityLog(relationshipId, {
        surface: 'modal',
        refreshOnHookMount: true
    });
    const content = relationshipError || activityLogError ? /*#__PURE__*/ _jsx(GenericError, {}) : !relationship || relationshipLoading || activityLogLoading ? /*#__PURE__*/ _jsx(Spinner, {
        centeredInBox: true,
        centerBoxHeight: "100%"
    }) : /*#__PURE__*/ _jsx("div", {
        children: activityLog.map((logItem, idx)=>/*#__PURE__*/ _jsx(ActivityLogItem, {
                isFirst: idx === 0,
                isLast: idx === activityLog.length - 1,
                vendorName: relationshipModel.sellerFullName(relationship) || '',
                clientName: relationshipModel.buyerFullName(relationship) || '',
                entry: logItem,
                relationship: relationship,
                variant: "transparent"
            }, logItem.id()))
    });
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'activity_log_confirm'
            },
            secondaryButton: {
                name: 'activity_log_cancel'
            }
        },
        title: proposalsDashboardTexts.activityLogModalTitle(),
        testId: ActivityLogModalTID.Root(),
        width: "980px",
        textAlignCenter: false,
        content: /*#__PURE__*/ _jsx("div", {
            className: styles.content,
            children: content
        }),
        primaryButtonLabel: commonTexts.buttons.close(),
        onPrimaryButtonClick: closeModal,
        onCloseButtonClick: closeModal
    });
}
